import i18n from '../../../localization/i18n';

export interface ApiErrorLike {
  status?: number;
  httpStatus?: number;
  error?: string;
  error_code?: string;
  error_description?: string;
  response?: {
    status?: number;
    data?: {
      error?: string;
      error_code?: string;
      error_description?: string;
    };
  };
}

export const getApiErrorMessage = (
  error: ApiErrorLike | boolean | null | undefined,
  t: (key: string) => string,
  basePath: string
): string => {
  const defaultKey = `${basePath}.DEFAULT`;
  if (!error || error === true) {
    return t(defaultKey);
  }

  const status = error.response?.status ?? error.httpStatus ?? error.status;
  const data = error.response?.data ?? error;
  const code = data?.error_code ?? data?.error;

  const candidates = [
    code ? `${basePath}.CODES.${code}` : undefined,
    status ? `${basePath}.STATUS.${status}` : undefined,
    defaultKey
  ].filter((key): key is string => Boolean(key));

  const match = candidates.find(key => i18n.exists(key));
  return t(match ?? defaultKey);
};
